import React from 'react';
import PropTypes from 'prop-types';
import { Table, Form, Input } from 'semantic-ui-react';
import i18next from 'i18next';

import './DayCellForm.scss';

const DayCellForm = ({ segment, updateSegment, figureSegmentState }) => {

    let isUntilTomorrow = false;
    if(segment.days.from < segment.days.until || (segment.days.from === 7 && segment.days.until === 1)) {
        isUntilTomorrow = true;
    }
    const exactHoursForm = (
        <Form>
            <Form.Group>
                <Form.Field
                    control={Input}
                    label={i18next.t('openTime')}
                    type="time"
                    icon='clock'
                    iconPosition='left'
                    value={segment.openTime}
                    error={!segment.openTime}
                    onChange={({ target }) => updateSegment({ openTime: target.value })}
                />
            </Form.Group>
            <Form.Group>
                <Form.Field
                    control={Input}
                    label={
                        `${i18next.t('closeTime')}${isUntilTomorrow ? ` (${i18next.t('schedule.nextDay')})` : ''}`
                    }
                    type="time"
                    icon='clock'
                    iconPosition='left'
                    value={segment.closeTime}
                    error={!segment.closeTime}
                    onChange={({ target }) => updateSegment({ closeTime: target.value })}
                />
            </Form.Group>
        </Form>
    );

    return (
        <Table.Cell>        
            {figureSegmentState(segment) === 'exactHours' ? exactHoursForm : null}
        </Table.Cell>
    );
};

DayCellForm.propTypes = {
    segment: PropTypes.object,
    figureSegmentState: PropTypes.func,
    updateSegment: PropTypes.func,
    
};

export default DayCellForm;